import { filterNulls as fn } from '../src/filterNulls';
export const filterNulls = fn;
